import React, { useEffect } from 'react';
import Calendar from "./Calendar";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {connect} from "react-redux";
import {addMinutes} from "../../utils";
import {createBlockedTimeAction, deleteBlockedTimeAction} from "../../store/actionCreators";
import Box from "@material-ui/core/Box";
import {useTranslation} from "react-i18next";
import Button from "@material-ui/core/Button";
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import {Typography} from "@material-ui/core";
import ScheduleSkeleton from "../ScheduleSkeleton";
import {useHistory} from "react-router-dom";
const useStyles = makeStyles((theme) => {
    return {
        root: {
            flexGrow: 1,
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            paddingTop: theme.spacing(1),
        },

    }
});

const Schedule = ({businessHours, appointments, isAdmin, supplierId, createBlockedTime, deleteBlockedTime, handleBack, handleNext,supplier, getSupplierData}) => {
    const classes = useStyles();
    const theme = useTheme()
    const {t} = useTranslation()
    const history = useHistory()
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))

    useEffect(()=>{
        if(supplier && supplier?.personalData?.professionId === null){
            history.push('/edit-supplier')
        }
    },[supplier, supplier?.personalData?.professionId])

    return <div className={classes.root} style={{width: isDesktop ? theme.maxContentWidth : null}}>
        {!isAdmin && <Box pb={1} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
            <Button onClick={handleBack} color={'primary'} width={'50px'}
                    startIcon={<NavigateNextIcon size={'small'}/>}>{t('back')}</Button>
            <Typography variant={"subtitle2"} color={'primary'}
                        align={'center'}>{t('press_available_date')}</Typography>
            <Box width={'70px'}></Box>
        </Box>}
        {businessHours ?
            <Calendar events={appointments} businessHours={businessHours} isAdmin={isAdmin} handleNext={handleNext}
                      createBlockedTime={createBlockedTime} deleteBlockedTime={deleteBlockedTime}
                      supplierId={supplierId}/> : <ScheduleSkeleton/>}
    </div>
}
const mapStateToProps = (state, {isAdmin}) => {
    const customer = JSON.parse(localStorage.getItem('customer'))
    const appointments = state.general.supplier?.appointments?.map(({_id: appointmentId, processId, dateAndTime, activity, customerId: {heName: customerName, _id: customerId}}) => {
        const {duration, subProfessionName, price} = typeof activity === 'object' ? activity : {
            duration: 60,
            subProfessionName: ''
        }
        const start = new Date(dateAndTime)
        const currentCustomer = customer?.name === customerName
        const transaction = state.general.supplier?.transactions?.find(transition => transition.processId === processId)
        const isPaid = transaction?.updatedData?.status === '1';
        const paidText = isAdmin ? isPaid ? 'pagado' : 'no pagado' : ''
        return {
            title: isAdmin || currentCustomer ? [customerName, subProfessionName, duration + ' min', paidText] : [],
            start,
            end: addMinutes(start, duration),
            color: isAdmin ? '#9c27b0' : currentCustomer ? '#9c27b0' : '#acaaaa',
            customerId,
            activityId: `${subProfessionName}@${duration}@${price}`,
            appointmentId,
        }
    }) || []
    const blockedTime = state.general.supplier?.blockedTimes.map(({startTime, endTime, _id, supplierId}) => ({
        start: startTime,
        end: endTime,
        color: '#acaaaa',
        blockedTimeId: _id,
        supplierId
    })) || []
    return {
        businessHours: state.general.supplier?.personalData?.businessHours,
        appointments: [...appointments, ...blockedTime],
        facebookId: state.general?.auth?.userID,
        supplierId: state.general?.supplier?.personalData._id,
        supplierName: state.general?.supplier?.personalData.fullName,
        supplier:state.general.supplier
    }
}
const mapDispatchToProps = dispatch => ({
    createBlockedTime: createBlockedTimeAction(dispatch),
    deleteBlockedTime: deleteBlockedTimeAction(dispatch),
})
export default connect(mapStateToProps, mapDispatchToProps)(Schedule);